// extracted by mini-css-extract-plugin
module.exports = {"container":"_14MNDnPCd3a8wUQegMJJgV","cancelBtn":"KBhQenv2keiBfQxDK0pr1","icon":"_2Y5vd9RiY_6erx6kn-H3lM","saveBtn":"_2s7EH2AmeHK-_7H-S2djvV"};